import React from 'react';
import PropTypes from 'prop-types';
import clone from 'ramda/src/clone';
import filter from 'ramda/src/filter';
import findIndex from 'ramda/src/findIndex';
import length from 'ramda/src/length';
import move from 'ramda/src/move';
import propEq from 'ramda/src/propEq';
import remove from 'ramda/src/remove';
import replace from 'ramda/src/replace';
import toLower from 'ramda/src/toLower';
import Icon from '@components/@core/Icon';
import Pagination from '@components/@core/Pagination';
import Thumbnail from '@components/@core/Thumbnail';
import EditDropdown from '@components/EditDropdown';
import { inPage } from '~/services/util';
import { LibraryTypes } from '~/services/config';

class DocumentsEdit extends React.PureComponent {
    state = { current: 1, per: 5 };

    handlePagination = (e) => {
        this.setState({ current: e });
    };

    handlePer = (e) => {
        this.setState({ per: e });
    };

    handleSelectMenu = (item) => (e) => {
        const { data } = this.props;
        const index = findIndex(propEq('id', item.id), data);
        let modules = clone(data);
        switch (e) {
            case 'move up':
                modules = move(index, index - 1, modules);
                break;
            case 'move down':
                modules = move(index, index + 1, modules);
                break;
            case 'remove':
                modules = remove(index, 1, modules);
                break;
            default:
                break;
        }
        this.props.onChange(modules);
    };

    render() {
        const { current, per } = this.state;
        const { data } = this.props;

        return (
            <div className="career-required-instances">
                <div className="documents">
                    {data.map((item, index) => {
                        const type = toLower(replace(/\s/g, '', item.data.type));
                        const thumbnail = LibraryTypes[type].icon;
                        let dotsMenu = ['Move Down', 'Move Up', 'Remove'];
                        if (index === 0) {
                            dotsMenu = filter((x) => x !== 'Move Up', dotsMenu);
                        }
                        if (length(data) === index + 1) {
                            dotsMenu = filter((x) => x !== 'Move Down', dotsMenu);
                        }
                        if (inPage(index, current, per)) {
                            return (
                                <div className="d-flex jc-between py-2" key={`doc${index}`}>
                                    <div className="d-flex ai-center">
                                        <Icon name="far fa-circle me-3" size={25} color="#969faa" />
                                        <Thumbnail source={thumbnail} label={item.data.type} size="tiny" />
                                        <div className="ml-3">
                                            <p className="dsl-b14 text-400 mb-1">{item.title}</p>
                                            <p className="dsl-m12 mb-0">Completed: none</p>
                                        </div>
                                    </div>
                                    <div className="edit">
                                        <EditDropdown options={dotsMenu} onChange={this.handleSelectMenu(item)} />
                                    </div>
                                </div>
                            );
                        }
                    })}
                </div>
                <Pagination current={current} per={per} pers={[5, 10, 'all']} total={Math.ceil(data.length / per)} onChange={this.handlePagination} onPer={this.handlePer} />
            </div>
        );
    }
}

DocumentsEdit.propTypes = {
    data: PropTypes.array,
    onChange: PropTypes.func,
};

DocumentsEdit.defaultProps = {
    data: [],
    onChange: () => {},
};

export default DocumentsEdit;
